import ExpandLessIcon from "@mui/icons-material/ExpandLess"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { IconButton, Typography } from "@mui/material"
import ListItemText from "@mui/material/ListItemText"
import { styled } from "@mui/material/styles"
import { Box } from "@mui/system"
import { useState } from "react"

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  padding: 0,
  marginLeft: "8px",
  color: "black"
}))

const TodoListReadMore = ({ id, categoryName, description }) => {
  const [isReadMoreShown, setReadMoreShown] = useState(false)

  const ToggleBtn = () => {
    setReadMoreShown((prevState) => !prevState)
  }

  return (
    <>
      <ListItemText
        primary={
          <Box p={0} display="flex" gap={categoryName ? "2px" : null}>
            <Typography sx={{ ml: 2, fontSize: "18px" }} variant="bodyMedium" fontWeight="600">
              {categoryName ? `${categoryName}:` : categoryName}
            </Typography>
            <Typography sx={{ fontSize: "18px" }} variant="bodyMedium">
              {isReadMoreShown
                ? description
                : description.length < 50
                ? description
                : description.substr(0, 50) + "..."}
            </Typography>
          </Box>
        }
      />
      <Typography variant="bodyMedium" fontWeight="300">
        {id && id.length > 0 ? "#" + id : null}
      </Typography>
      {description.length > 50 && (
        <StyledIconButton onClick={ToggleBtn}>
          {isReadMoreShown ? <ExpandLessIcon fontSize="large" /> : <ExpandMoreIcon fontSize="large" />}
        </StyledIconButton>
      )}
    </>
  )
}

export default TodoListReadMore
